import { Button, Card, Col, Form, Input, Row, Select, Space } from "antd"
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons"
import type React from "react"
import type { PointTransactionQueryParams } from "@/services/gamification/pointTransactionApi"

interface PointTransactionSearchFormProps {
  onSearch: (values: PointTransactionQueryParams) => void
  loading?: boolean
  initialValues?: PointTransactionQueryParams
}

export const PointTransactionSearchForm: React.FC<PointTransactionSearchFormProps> = ({
  onSearch,
  loading = false,
  initialValues,
}) => {
  const [form] = Form.useForm()

  const handleFinish = (values: any) => {
    onSearch(values)
  }

  const handleReset = () => {
    form.resetFields()
    onSearch({})
  }

  return (
    <Card className="shadow-xs mb-2">
      <Form form={form} layout="vertical" onFinish={handleFinish} initialValues={initialValues}>
        <Row gutter={[16, 8]}>
          <Col xs={24} sm={12} md={10} lg={8}>
            <Form.Item label="Tài khoản (Tên, Email hoặc #ID)" name="search">
              <Input placeholder="Nhập tên, email hoặc #ID..." allowClear />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={8} lg={8}>
            <Form.Item label="Loại sự kiện" name="event_type">
              <Select
                placeholder="Tất cả sự kiện"
                allowClear
                options={[
                  { label: "Ôn tập SRS (srs_study_completed)", value: "srs_study_completed" },
                  { label: "Thưởng chuỗi (streak_reward)", value: "streak_reward" },
                  { label: "Hoàn thành bộ từ (set_completed)", value: "set_completed" },
                  { label: "Thăng cấp độ (level_up)", value: "level_up" },
                  { label: "Admin điều chỉnh (admin_adjustment)", value: "admin_adjustment" },
                ]}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={6} lg={8} className="flex items-end">
            <Form.Item className="w-full">
              <Space className="w-full justify-end">
                <Button icon={<ReloadOutlined />} onClick={handleReset}>
                  Đặt lại
                </Button>
                <Button type="primary" htmlType="submit" icon={<SearchOutlined />} loading={loading}>
                  Tìm kiếm
                </Button>
              </Space>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  )
}

export default PointTransactionSearchForm
